import React from "react";
import { Link } from "react-router-dom";
import BrilloLogo from "@/components/BrilloLogo";
import { CREDITARIA_URL } from "@/lib/api";

export default function Navbar() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-[#e5e7eb] bg-white/85 backdrop-blur-md">
      <div className="bf-container flex items-center justify-between py-4">
        <Link to="/" data-testid="nav-home-link" aria-label="Ir al inicio">
          <BrilloLogo className="h-11 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-[#333333]">
          <a href="#soluciones" className="bf-link" data-testid="nav-soluciones">Soluciones</a>
          <a href="#proceso" className="bf-link" data-testid="nav-proceso">Cómo lo hacemos</a>
          <a href="#beneficios" className="bf-link" data-testid="nav-beneficios">Beneficios</a>
          <a href="#testimonios" className="bf-link" data-testid="nav-testimonios">Testimonios</a>
          <a href="#faq" className="bf-link" data-testid="nav-faq">FAQ</a>
          <a href="#contacto" className="bf-link" data-testid="nav-contacto">Contacto</a>
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/login"
            className="hidden md:inline-flex text-xs font-medium text-[#666666] hover:text-[#04b0ba] transition-colors"
            data-testid="nav-admin-link"
          >
            Admin
          </Link>
          <a
            href={CREDITARIA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-button"
            className="bf-btn-primary rounded-full px-5 py-2.5 text-sm font-semibold"
          >
            Precalificarme
          </a>
        </div>
      </div>
    </header>
  );
}
